import { ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'

@Component({
	selector: 'atyl-nomade-security-question',
	templateUrl: './security-question.component.html',
	styleUrls: ['./security-question.component.scss']
})
export class SecurityQuestionComponent {

	question: string = ''
	error: string = ''
	responseFg: FormGroup = new FormGroup({
		response: new FormControl('', [Validators.required])
	})
	@Output() questionAnswered: EventEmitter<boolean> = new EventEmitter<boolean>()
	constructor(
		private changeDetectorRef: ChangeDetectorRef
	) { }

	ngOnInit() {
		this.question = window.atob(localStorage.getItem('securityQuestion'))
		this.changeDetectorRef.detectChanges()
	}
	validRespone() {
		if (this.responseFg.controls.response.value == window.atob(localStorage.getItem('securityAnswer'))) {
			this.error = ''
			this.questionAnswered.emit(true)
		}
		else {
			this.error = 'votre réponse est incorrecte'
			this.questionAnswered.emit(false)
		}
	}

}
